"use client"

import * as SwitchPrimitives from "@radix-ui/react-switch"
import * as React from "react"

import * as styles from "./switch.styled"

const Switch = React.forwardRef<
  React.ComponentRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root className={styles.root(className)} {...props} ref={ref}>
    <SwitchPrimitives.Thumb className={styles.thumb(className, props.disabled)} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
